"use strict";

// source: spine/system/server/entity_log_events.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../spine/options_pb.js');

goog.object.extend(proto, spine_options_pb);

var google_protobuf_any_pb = require('../../../google/protobuf/any_pb.js');

goog.object.extend(proto, google_protobuf_any_pb);

var google_protobuf_timestamp_pb = require('../../../google/protobuf/timestamp_pb.js');

goog.object.extend(proto, google_protobuf_timestamp_pb);

var spine_core_diagnostics_pb = require('../../../spine/core/diagnostics_pb.js');

goog.object.extend(proto, spine_core_diagnostics_pb);

var spine_core_command_pb = require('../../../spine/core/command_pb.js');

goog.object.extend(proto, spine_core_command_pb);

var spine_core_event_pb = require('../../../spine/core/event_pb.js');

goog.object.extend(proto, spine_core_event_pb);

var spine_core_version_pb = require('../../../spine/core/version_pb.js');

goog.object.extend(proto, spine_core_version_pb);

var spine_system_server_entity_type_pb = require('../../../spine/system/server/entity_type_pb.js');

goog.object.extend(proto, spine_system_server_entity_type_pb);
goog.exportSymbol('proto.spine.system.server.CommandDispatchedToHandler', null, global);
goog.exportSymbol('proto.spine.system.server.EntityArchived', null, global);
goog.exportSymbol('proto.spine.system.server.EntityCreated', null, global);
goog.exportSymbol('proto.spine.system.server.EntityDeleted', null, global);
goog.exportSymbol('proto.spine.system.server.EntityDeleted.DeletionCase', null, global);
goog.exportSymbol('proto.spine.system.server.EntityRestored', null, global);
goog.exportSymbol('proto.spine.system.server.EntityStateChanged', null, global);
goog.exportSymbol('proto.spine.system.server.EntityUnarchived', null, global);
goog.exportSymbol('proto.spine.system.server.EventDispatchedToReactor', null, global);
goog.exportSymbol('proto.spine.system.server.EventDispatchedToSubscriber', null, global);
goog.exportSymbol('proto.spine.system.server.EventImported', null, global);
goog.exportSymbol('proto.spine.system.server.MigrationApplied', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.spine.system.server.EntityCreated = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.system.server.EntityCreated, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EntityCreated.displayName = 'proto.spine.system.server.EntityCreated';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.EventDispatchedToSubscriber = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.system.server.EventDispatchedToSubscriber, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EventDispatchedToSubscriber.displayName = 'proto.spine.system.server.EventDispatchedToSubscriber';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.EventDispatchedToReactor = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.system.server.EventDispatchedToReactor, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EventDispatchedToReactor.displayName = 'proto.spine.system.server.EventDispatchedToReactor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.CommandDispatchedToHandler = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.system.server.CommandDispatchedToHandler, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.CommandDispatchedToHandler.displayName = 'proto.spine.system.server.CommandDispatchedToHandler';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.EventImported = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.system.server.EventImported, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EventImported.displayName = 'proto.spine.system.server.EventImported';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.EntityStateChanged = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityStateChanged.repeatedFields_, null);
};

goog.inherits(proto.spine.system.server.EntityStateChanged, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EntityStateChanged.displayName = 'proto.spine.system.server.EntityStateChanged';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.EntityArchived = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityArchived.repeatedFields_, null);
};

goog.inherits(proto.spine.system.server.EntityArchived, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EntityArchived.displayName = 'proto.spine.system.server.EntityArchived';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.EntityDeleted = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityDeleted.repeatedFields_, proto.spine.system.server.EntityDeleted.oneofGroups_);
};

goog.inherits(proto.spine.system.server.EntityDeleted, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EntityDeleted.displayName = 'proto.spine.system.server.EntityDeleted';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.EntityUnarchived = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityUnarchived.repeatedFields_, null);
};

goog.inherits(proto.spine.system.server.EntityUnarchived, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EntityUnarchived.displayName = 'proto.spine.system.server.EntityUnarchived';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.EntityRestored = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityRestored.repeatedFields_, null);
};

goog.inherits(proto.spine.system.server.EntityRestored, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.EntityRestored.displayName = 'proto.spine.system.server.EntityRestored';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.system.server.MigrationApplied = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.system.server.MigrationApplied, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.system.server.MigrationApplied.displayName = 'proto.spine.system.server.MigrationApplied';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EntityCreated.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EntityCreated.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EntityCreated} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EntityCreated.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      entity: (f = msg.getEntity()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      kind: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityCreated}
 */


proto.spine.system.server.EntityCreated.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityCreated();
  return proto.spine.system.server.EntityCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityCreated}
 */


proto.spine.system.server.EntityCreated.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setEntity(value);
        break;

      case 2:
        var value =
        /** @type {!proto.EntityOption.Kind} */
        reader.readEnum();
        msg.setKind(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EntityCreated.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityCreated.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EntityCreated.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEntity();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getKind();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
};
/**
 * optional spine.core.MessageId entity = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityCreated.prototype.getEntity = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EntityCreated} returns this
*/


proto.spine.system.server.EntityCreated.prototype.setEntity = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityCreated} returns this
 */


proto.spine.system.server.EntityCreated.prototype.clearEntity = function () {
  return this.setEntity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityCreated.prototype.hasEntity = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional EntityOption.Kind kind = 2;
 * @return {!proto.EntityOption.Kind}
 */


proto.spine.system.server.EntityCreated.prototype.getKind = function () {
  return (
    /** @type {!proto.EntityOption.Kind} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {!proto.EntityOption.Kind} value
 * @return {!proto.spine.system.server.EntityCreated} returns this
 */


proto.spine.system.server.EntityCreated.prototype.setKind = function (value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EventDispatchedToSubscriber.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EventDispatchedToSubscriber.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EventDispatchedToSubscriber} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EventDispatchedToSubscriber.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      receiver: (f = msg.getReceiver()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      payload: (f = msg.getPayload()) && spine_core_event_pb.Event.toObject(includeInstance, f),
      whenDispatched: (f = msg.getWhenDispatched()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      entityType: (f = msg.getEntityType()) && spine_system_server_entity_type_pb.EntityTypeName.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber}
 */


proto.spine.system.server.EventDispatchedToSubscriber.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EventDispatchedToSubscriber();
  return proto.spine.system.server.EventDispatchedToSubscriber.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EventDispatchedToSubscriber} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber}
 */


proto.spine.system.server.EventDispatchedToSubscriber.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setReceiver(value);
        break;

      case 2:
        var value = new spine_core_event_pb.Event();
        reader.readMessage(value, spine_core_event_pb.Event.deserializeBinaryFromReader);
        msg.setPayload(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhenDispatched(value);
        break;

      case 4:
        var value = new spine_system_server_entity_type_pb.EntityTypeName();
        reader.readMessage(value, spine_system_server_entity_type_pb.EntityTypeName.deserializeBinaryFromReader);
        msg.setEntityType(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EventDispatchedToSubscriber.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EventDispatchedToSubscriber} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EventDispatchedToSubscriber.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getReceiver();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getPayload();

  if (f != null) {
    writer.writeMessage(2, f, spine_core_event_pb.Event.serializeBinaryToWriter);
  }

  f = message.getWhenDispatched();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getEntityType();

  if (f != null) {
    writer.writeMessage(4, f, spine_system_server_entity_type_pb.EntityTypeName.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId receiver = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.getReceiver = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber} returns this
*/


proto.spine.system.server.EventDispatchedToSubscriber.prototype.setReceiver = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber} returns this
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.clearReceiver = function () {
  return this.setReceiver(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.hasReceiver = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional spine.core.Event payload = 2;
 * @return {?proto.spine.core.Event}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.getPayload = function () {
  return (
    /** @type{?proto.spine.core.Event} */
    jspb.Message.getWrapperField(this, spine_core_event_pb.Event, 2)
  );
};
/**
 * @param {?proto.spine.core.Event|undefined} value
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber} returns this
*/


proto.spine.system.server.EventDispatchedToSubscriber.prototype.setPayload = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber} returns this
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.clearPayload = function () {
  return this.setPayload(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.hasPayload = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp when_dispatched = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.getWhenDispatched = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber} returns this
*/


proto.spine.system.server.EventDispatchedToSubscriber.prototype.setWhenDispatched = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber} returns this
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.clearWhenDispatched = function () {
  return this.setWhenDispatched(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.hasWhenDispatched = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional EntityTypeName entity_type = 4;
 * @return {?proto.spine.system.server.EntityTypeName}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.getEntityType = function () {
  return (
    /** @type{?proto.spine.system.server.EntityTypeName} */
    jspb.Message.getWrapperField(this, spine_system_server_entity_type_pb.EntityTypeName, 4)
  );
};
/**
 * @param {?proto.spine.system.server.EntityTypeName|undefined} value
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber} returns this
*/


proto.spine.system.server.EventDispatchedToSubscriber.prototype.setEntityType = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber} returns this
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.clearEntityType = function () {
  return this.setEntityType(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventDispatchedToSubscriber.prototype.hasEntityType = function () {
  return jspb.Message.getField(this, 4) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EventDispatchedToReactor.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EventDispatchedToReactor.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EventDispatchedToReactor} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EventDispatchedToReactor.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      receiver: (f = msg.getReceiver()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      payload: (f = msg.getPayload()) && spine_core_event_pb.Event.toObject(includeInstance, f),
      whenDispatched: (f = msg.getWhenDispatched()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      entityType: (f = msg.getEntityType()) && spine_system_server_entity_type_pb.EntityTypeName.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EventDispatchedToReactor}
 */


proto.spine.system.server.EventDispatchedToReactor.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EventDispatchedToReactor();
  return proto.spine.system.server.EventDispatchedToReactor.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EventDispatchedToReactor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EventDispatchedToReactor}
 */


proto.spine.system.server.EventDispatchedToReactor.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setReceiver(value);
        break;

      case 2:
        var value = new spine_core_event_pb.Event();
        reader.readMessage(value, spine_core_event_pb.Event.deserializeBinaryFromReader);
        msg.setPayload(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhenDispatched(value);
        break;

      case 4:
        var value = new spine_system_server_entity_type_pb.EntityTypeName();
        reader.readMessage(value, spine_system_server_entity_type_pb.EntityTypeName.deserializeBinaryFromReader);
        msg.setEntityType(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EventDispatchedToReactor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EventDispatchedToReactor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EventDispatchedToReactor.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getReceiver();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getPayload();

  if (f != null) {
    writer.writeMessage(2, f, spine_core_event_pb.Event.serializeBinaryToWriter);
  }

  f = message.getWhenDispatched();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getEntityType();

  if (f != null) {
    writer.writeMessage(4, f, spine_system_server_entity_type_pb.EntityTypeName.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId receiver = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.getReceiver = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EventDispatchedToReactor} returns this
*/


proto.spine.system.server.EventDispatchedToReactor.prototype.setReceiver = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventDispatchedToReactor} returns this
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.clearReceiver = function () {
  return this.setReceiver(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.hasReceiver = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional spine.core.Event payload = 2;
 * @return {?proto.spine.core.Event}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.getPayload = function () {
  return (
    /** @type{?proto.spine.core.Event} */
    jspb.Message.getWrapperField(this, spine_core_event_pb.Event, 2)
  );
};
/**
 * @param {?proto.spine.core.Event|undefined} value
 * @return {!proto.spine.system.server.EventDispatchedToReactor} returns this
*/


proto.spine.system.server.EventDispatchedToReactor.prototype.setPayload = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventDispatchedToReactor} returns this
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.clearPayload = function () {
  return this.setPayload(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.hasPayload = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp when_dispatched = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.getWhenDispatched = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.EventDispatchedToReactor} returns this
*/


proto.spine.system.server.EventDispatchedToReactor.prototype.setWhenDispatched = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventDispatchedToReactor} returns this
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.clearWhenDispatched = function () {
  return this.setWhenDispatched(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.hasWhenDispatched = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional EntityTypeName entity_type = 4;
 * @return {?proto.spine.system.server.EntityTypeName}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.getEntityType = function () {
  return (
    /** @type{?proto.spine.system.server.EntityTypeName} */
    jspb.Message.getWrapperField(this, spine_system_server_entity_type_pb.EntityTypeName, 4)
  );
};
/**
 * @param {?proto.spine.system.server.EntityTypeName|undefined} value
 * @return {!proto.spine.system.server.EventDispatchedToReactor} returns this
*/


proto.spine.system.server.EventDispatchedToReactor.prototype.setEntityType = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventDispatchedToReactor} returns this
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.clearEntityType = function () {
  return this.setEntityType(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventDispatchedToReactor.prototype.hasEntityType = function () {
  return jspb.Message.getField(this, 4) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.CommandDispatchedToHandler.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.CommandDispatchedToHandler.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.CommandDispatchedToHandler} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.CommandDispatchedToHandler.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      receiver: (f = msg.getReceiver()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      payload: (f = msg.getPayload()) && spine_core_command_pb.Command.toObject(includeInstance, f),
      whenDispatched: (f = msg.getWhenDispatched()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      entityType: (f = msg.getEntityType()) && spine_system_server_entity_type_pb.EntityTypeName.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.CommandDispatchedToHandler}
 */


proto.spine.system.server.CommandDispatchedToHandler.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.CommandDispatchedToHandler();
  return proto.spine.system.server.CommandDispatchedToHandler.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.CommandDispatchedToHandler} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.CommandDispatchedToHandler}
 */


proto.spine.system.server.CommandDispatchedToHandler.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setReceiver(value);
        break;

      case 2:
        var value = new spine_core_command_pb.Command();
        reader.readMessage(value, spine_core_command_pb.Command.deserializeBinaryFromReader);
        msg.setPayload(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhenDispatched(value);
        break;

      case 4:
        var value = new spine_system_server_entity_type_pb.EntityTypeName();
        reader.readMessage(value, spine_system_server_entity_type_pb.EntityTypeName.deserializeBinaryFromReader);
        msg.setEntityType(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.CommandDispatchedToHandler.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.CommandDispatchedToHandler} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.CommandDispatchedToHandler.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getReceiver();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getPayload();

  if (f != null) {
    writer.writeMessage(2, f, spine_core_command_pb.Command.serializeBinaryToWriter);
  }

  f = message.getWhenDispatched();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getEntityType();

  if (f != null) {
    writer.writeMessage(4, f, spine_system_server_entity_type_pb.EntityTypeName.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId receiver = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.getReceiver = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.CommandDispatchedToHandler} returns this
*/


proto.spine.system.server.CommandDispatchedToHandler.prototype.setReceiver = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.CommandDispatchedToHandler} returns this
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.clearReceiver = function () {
  return this.setReceiver(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.hasReceiver = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional spine.core.Command payload = 2;
 * @return {?proto.spine.core.Command}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.getPayload = function () {
  return (
    /** @type{?proto.spine.core.Command} */
    jspb.Message.getWrapperField(this, spine_core_command_pb.Command, 2)
  );
};
/**
 * @param {?proto.spine.core.Command|undefined} value
 * @return {!proto.spine.system.server.CommandDispatchedToHandler} returns this
*/


proto.spine.system.server.CommandDispatchedToHandler.prototype.setPayload = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.CommandDispatchedToHandler} returns this
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.clearPayload = function () {
  return this.setPayload(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.hasPayload = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp when_dispatched = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.getWhenDispatched = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.CommandDispatchedToHandler} returns this
*/


proto.spine.system.server.CommandDispatchedToHandler.prototype.setWhenDispatched = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.CommandDispatchedToHandler} returns this
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.clearWhenDispatched = function () {
  return this.setWhenDispatched(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.hasWhenDispatched = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional EntityTypeName entity_type = 4;
 * @return {?proto.spine.system.server.EntityTypeName}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.getEntityType = function () {
  return (
    /** @type{?proto.spine.system.server.EntityTypeName} */
    jspb.Message.getWrapperField(this, spine_system_server_entity_type_pb.EntityTypeName, 4)
  );
};
/**
 * @param {?proto.spine.system.server.EntityTypeName|undefined} value
 * @return {!proto.spine.system.server.CommandDispatchedToHandler} returns this
*/


proto.spine.system.server.CommandDispatchedToHandler.prototype.setEntityType = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.CommandDispatchedToHandler} returns this
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.clearEntityType = function () {
  return this.setEntityType(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.CommandDispatchedToHandler.prototype.hasEntityType = function () {
  return jspb.Message.getField(this, 4) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EventImported.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EventImported.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EventImported} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EventImported.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      receiver: (f = msg.getReceiver()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      payload: (f = msg.getPayload()) && spine_core_event_pb.Event.toObject(includeInstance, f),
      whenImported: (f = msg.getWhenImported()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      entityType: (f = msg.getEntityType()) && spine_system_server_entity_type_pb.EntityTypeName.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EventImported}
 */


proto.spine.system.server.EventImported.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EventImported();
  return proto.spine.system.server.EventImported.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EventImported} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EventImported}
 */


proto.spine.system.server.EventImported.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setReceiver(value);
        break;

      case 2:
        var value = new spine_core_event_pb.Event();
        reader.readMessage(value, spine_core_event_pb.Event.deserializeBinaryFromReader);
        msg.setPayload(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhenImported(value);
        break;

      case 4:
        var value = new spine_system_server_entity_type_pb.EntityTypeName();
        reader.readMessage(value, spine_system_server_entity_type_pb.EntityTypeName.deserializeBinaryFromReader);
        msg.setEntityType(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EventImported.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EventImported.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EventImported} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EventImported.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getReceiver();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getPayload();

  if (f != null) {
    writer.writeMessage(2, f, spine_core_event_pb.Event.serializeBinaryToWriter);
  }

  f = message.getWhenImported();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getEntityType();

  if (f != null) {
    writer.writeMessage(4, f, spine_system_server_entity_type_pb.EntityTypeName.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId receiver = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EventImported.prototype.getReceiver = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EventImported} returns this
*/


proto.spine.system.server.EventImported.prototype.setReceiver = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventImported} returns this
 */


proto.spine.system.server.EventImported.prototype.clearReceiver = function () {
  return this.setReceiver(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventImported.prototype.hasReceiver = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional spine.core.Event payload = 2;
 * @return {?proto.spine.core.Event}
 */


proto.spine.system.server.EventImported.prototype.getPayload = function () {
  return (
    /** @type{?proto.spine.core.Event} */
    jspb.Message.getWrapperField(this, spine_core_event_pb.Event, 2)
  );
};
/**
 * @param {?proto.spine.core.Event|undefined} value
 * @return {!proto.spine.system.server.EventImported} returns this
*/


proto.spine.system.server.EventImported.prototype.setPayload = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventImported} returns this
 */


proto.spine.system.server.EventImported.prototype.clearPayload = function () {
  return this.setPayload(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventImported.prototype.hasPayload = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp when_imported = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.EventImported.prototype.getWhenImported = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.EventImported} returns this
*/


proto.spine.system.server.EventImported.prototype.setWhenImported = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventImported} returns this
 */


proto.spine.system.server.EventImported.prototype.clearWhenImported = function () {
  return this.setWhenImported(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventImported.prototype.hasWhenImported = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional EntityTypeName entity_type = 4;
 * @return {?proto.spine.system.server.EntityTypeName}
 */


proto.spine.system.server.EventImported.prototype.getEntityType = function () {
  return (
    /** @type{?proto.spine.system.server.EntityTypeName} */
    jspb.Message.getWrapperField(this, spine_system_server_entity_type_pb.EntityTypeName, 4)
  );
};
/**
 * @param {?proto.spine.system.server.EntityTypeName|undefined} value
 * @return {!proto.spine.system.server.EventImported} returns this
*/


proto.spine.system.server.EventImported.prototype.setEntityType = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EventImported} returns this
 */


proto.spine.system.server.EventImported.prototype.clearEntityType = function () {
  return this.setEntityType(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EventImported.prototype.hasEntityType = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.spine.system.server.EntityStateChanged.repeatedFields_ = [3];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EntityStateChanged.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EntityStateChanged.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EntityStateChanged} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EntityStateChanged.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      entity: (f = msg.getEntity()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      oldState: (f = msg.getOldState()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
      newState: (f = msg.getNewState()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
      signalIdList: jspb.Message.toObjectList(msg.getSignalIdList(), spine_core_diagnostics_pb.MessageId.toObject, includeInstance),
      when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      newVersion: (f = msg.getNewVersion()) && spine_core_version_pb.Version.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityStateChanged}
 */


proto.spine.system.server.EntityStateChanged.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityStateChanged();
  return proto.spine.system.server.EntityStateChanged.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityStateChanged} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityStateChanged}
 */


proto.spine.system.server.EntityStateChanged.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setEntity(value);
        break;

      case 6:
        var value = new google_protobuf_any_pb.Any();
        reader.readMessage(value, google_protobuf_any_pb.Any.deserializeBinaryFromReader);
        msg.setOldState(value);
        break;

      case 2:
        var value = new google_protobuf_any_pb.Any();
        reader.readMessage(value, google_protobuf_any_pb.Any.deserializeBinaryFromReader);
        msg.setNewState(value);
        break;

      case 3:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.addSignalId(value);
        break;

      case 4:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhen(value);
        break;

      case 5:
        var value = new spine_core_version_pb.Version();
        reader.readMessage(value, spine_core_version_pb.Version.deserializeBinaryFromReader);
        msg.setNewVersion(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EntityStateChanged.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityStateChanged.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityStateChanged} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EntityStateChanged.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEntity();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getOldState();

  if (f != null) {
    writer.writeMessage(6, f, google_protobuf_any_pb.Any.serializeBinaryToWriter);
  }

  f = message.getNewState();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_any_pb.Any.serializeBinaryToWriter);
  }

  f = message.getSignalIdList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(3, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getWhen();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getNewVersion();

  if (f != null) {
    writer.writeMessage(5, f, spine_core_version_pb.Version.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId entity = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityStateChanged.prototype.getEntity = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
*/


proto.spine.system.server.EntityStateChanged.prototype.setEntity = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
 */


proto.spine.system.server.EntityStateChanged.prototype.clearEntity = function () {
  return this.setEntity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityStateChanged.prototype.hasEntity = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional google.protobuf.Any old_state = 6;
 * @return {?proto.google.protobuf.Any}
 */


proto.spine.system.server.EntityStateChanged.prototype.getOldState = function () {
  return (
    /** @type{?proto.google.protobuf.Any} */
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 6)
  );
};
/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
*/


proto.spine.system.server.EntityStateChanged.prototype.setOldState = function (value) {
  return jspb.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
 */


proto.spine.system.server.EntityStateChanged.prototype.clearOldState = function () {
  return this.setOldState(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityStateChanged.prototype.hasOldState = function () {
  return jspb.Message.getField(this, 6) != null;
};
/**
 * optional google.protobuf.Any new_state = 2;
 * @return {?proto.google.protobuf.Any}
 */


proto.spine.system.server.EntityStateChanged.prototype.getNewState = function () {
  return (
    /** @type{?proto.google.protobuf.Any} */
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2)
  );
};
/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
*/


proto.spine.system.server.EntityStateChanged.prototype.setNewState = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
 */


proto.spine.system.server.EntityStateChanged.prototype.clearNewState = function () {
  return this.setNewState(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityStateChanged.prototype.hasNewState = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * repeated spine.core.MessageId signal_id = 3;
 * @return {!Array<!proto.spine.core.MessageId>}
 */


proto.spine.system.server.EntityStateChanged.prototype.getSignalIdList = function () {
  return (
    /** @type{!Array<!proto.spine.core.MessageId>} */
    jspb.Message.getRepeatedWrapperField(this, spine_core_diagnostics_pb.MessageId, 3)
  );
};
/**
 * @param {!Array<!proto.spine.core.MessageId>} value
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
*/


proto.spine.system.server.EntityStateChanged.prototype.setSignalIdList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.spine.core.MessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityStateChanged.prototype.addSignalId = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.spine.core.MessageId, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
 */


proto.spine.system.server.EntityStateChanged.prototype.clearSignalIdList = function () {
  return this.setSignalIdList([]);
};
/**
 * optional google.protobuf.Timestamp when = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.EntityStateChanged.prototype.getWhen = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
*/


proto.spine.system.server.EntityStateChanged.prototype.setWhen = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
 */


proto.spine.system.server.EntityStateChanged.prototype.clearWhen = function () {
  return this.setWhen(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityStateChanged.prototype.hasWhen = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * optional spine.core.Version new_version = 5;
 * @return {?proto.spine.core.Version}
 */


proto.spine.system.server.EntityStateChanged.prototype.getNewVersion = function () {
  return (
    /** @type{?proto.spine.core.Version} */
    jspb.Message.getWrapperField(this, spine_core_version_pb.Version, 5)
  );
};
/**
 * @param {?proto.spine.core.Version|undefined} value
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
*/


proto.spine.system.server.EntityStateChanged.prototype.setNewVersion = function (value) {
  return jspb.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityStateChanged} returns this
 */


proto.spine.system.server.EntityStateChanged.prototype.clearNewVersion = function () {
  return this.setNewVersion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityStateChanged.prototype.hasNewVersion = function () {
  return jspb.Message.getField(this, 5) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.spine.system.server.EntityArchived.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EntityArchived.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EntityArchived.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EntityArchived} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EntityArchived.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      entity: (f = msg.getEntity()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      signalIdList: jspb.Message.toObjectList(msg.getSignalIdList(), spine_core_diagnostics_pb.MessageId.toObject, includeInstance),
      when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      version: (f = msg.getVersion()) && spine_core_version_pb.Version.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityArchived}
 */


proto.spine.system.server.EntityArchived.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityArchived();
  return proto.spine.system.server.EntityArchived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityArchived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityArchived}
 */


proto.spine.system.server.EntityArchived.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setEntity(value);
        break;

      case 2:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.addSignalId(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhen(value);
        break;

      case 4:
        var value = new spine_core_version_pb.Version();
        reader.readMessage(value, spine_core_version_pb.Version.deserializeBinaryFromReader);
        msg.setVersion(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EntityArchived.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityArchived.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityArchived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EntityArchived.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEntity();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getSignalIdList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getWhen();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getVersion();

  if (f != null) {
    writer.writeMessage(4, f, spine_core_version_pb.Version.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId entity = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityArchived.prototype.getEntity = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EntityArchived} returns this
*/


proto.spine.system.server.EntityArchived.prototype.setEntity = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityArchived} returns this
 */


proto.spine.system.server.EntityArchived.prototype.clearEntity = function () {
  return this.setEntity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityArchived.prototype.hasEntity = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * repeated spine.core.MessageId signal_id = 2;
 * @return {!Array<!proto.spine.core.MessageId>}
 */


proto.spine.system.server.EntityArchived.prototype.getSignalIdList = function () {
  return (
    /** @type{!Array<!proto.spine.core.MessageId>} */
    jspb.Message.getRepeatedWrapperField(this, spine_core_diagnostics_pb.MessageId, 2)
  );
};
/**
 * @param {!Array<!proto.spine.core.MessageId>} value
 * @return {!proto.spine.system.server.EntityArchived} returns this
*/


proto.spine.system.server.EntityArchived.prototype.setSignalIdList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.spine.core.MessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityArchived.prototype.addSignalId = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.core.MessageId, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spine.system.server.EntityArchived} returns this
 */


proto.spine.system.server.EntityArchived.prototype.clearSignalIdList = function () {
  return this.setSignalIdList([]);
};
/**
 * optional google.protobuf.Timestamp when = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.EntityArchived.prototype.getWhen = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.EntityArchived} returns this
*/


proto.spine.system.server.EntityArchived.prototype.setWhen = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityArchived} returns this
 */


proto.spine.system.server.EntityArchived.prototype.clearWhen = function () {
  return this.setWhen(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityArchived.prototype.hasWhen = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional spine.core.Version version = 4;
 * @return {?proto.spine.core.Version}
 */


proto.spine.system.server.EntityArchived.prototype.getVersion = function () {
  return (
    /** @type{?proto.spine.core.Version} */
    jspb.Message.getWrapperField(this, spine_core_version_pb.Version, 4)
  );
};
/**
 * @param {?proto.spine.core.Version|undefined} value
 * @return {!proto.spine.system.server.EntityArchived} returns this
*/


proto.spine.system.server.EntityArchived.prototype.setVersion = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityArchived} returns this
 */


proto.spine.system.server.EntityArchived.prototype.clearVersion = function () {
  return this.setVersion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityArchived.prototype.hasVersion = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.spine.system.server.EntityDeleted.repeatedFields_ = [2];
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */

proto.spine.system.server.EntityDeleted.oneofGroups_ = [[5, 6]];
/**
 * @enum {number}
 */

proto.spine.system.server.EntityDeleted.DeletionCase = {
  DELETION_NOT_SET: 0,
  MARKED_AS_DELETED: 5,
  REMOVED_FROM_STORAGE: 6
};
/**
 * @return {proto.spine.system.server.EntityDeleted.DeletionCase}
 */

proto.spine.system.server.EntityDeleted.prototype.getDeletionCase = function () {
  return (
    /** @type {proto.spine.system.server.EntityDeleted.DeletionCase} */
    jspb.Message.computeOneofCase(this, proto.spine.system.server.EntityDeleted.oneofGroups_[0])
  );
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EntityDeleted.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EntityDeleted.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EntityDeleted} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EntityDeleted.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      entity: (f = msg.getEntity()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      signalIdList: jspb.Message.toObjectList(msg.getSignalIdList(), spine_core_diagnostics_pb.MessageId.toObject, includeInstance),
      when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      version: (f = msg.getVersion()) && spine_core_version_pb.Version.toObject(includeInstance, f),
      markedAsDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
      removedFromStorage: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityDeleted}
 */


proto.spine.system.server.EntityDeleted.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityDeleted();
  return proto.spine.system.server.EntityDeleted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityDeleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityDeleted}
 */


proto.spine.system.server.EntityDeleted.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setEntity(value);
        break;

      case 2:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.addSignalId(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhen(value);
        break;

      case 4:
        var value = new spine_core_version_pb.Version();
        reader.readMessage(value, spine_core_version_pb.Version.deserializeBinaryFromReader);
        msg.setVersion(value);
        break;

      case 5:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setMarkedAsDeleted(value);
        break;

      case 6:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setRemovedFromStorage(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EntityDeleted.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityDeleted.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityDeleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EntityDeleted.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEntity();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getSignalIdList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getWhen();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getVersion();

  if (f != null) {
    writer.writeMessage(4, f, spine_core_version_pb.Version.serializeBinaryToWriter);
  }

  f =
  /** @type {boolean} */
  jspb.Message.getField(message, 5);

  if (f != null) {
    writer.writeBool(5, f);
  }

  f =
  /** @type {boolean} */
  jspb.Message.getField(message, 6);

  if (f != null) {
    writer.writeBool(6, f);
  }
};
/**
 * optional spine.core.MessageId entity = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityDeleted.prototype.getEntity = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EntityDeleted} returns this
*/


proto.spine.system.server.EntityDeleted.prototype.setEntity = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityDeleted} returns this
 */


proto.spine.system.server.EntityDeleted.prototype.clearEntity = function () {
  return this.setEntity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityDeleted.prototype.hasEntity = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * repeated spine.core.MessageId signal_id = 2;
 * @return {!Array<!proto.spine.core.MessageId>}
 */


proto.spine.system.server.EntityDeleted.prototype.getSignalIdList = function () {
  return (
    /** @type{!Array<!proto.spine.core.MessageId>} */
    jspb.Message.getRepeatedWrapperField(this, spine_core_diagnostics_pb.MessageId, 2)
  );
};
/**
 * @param {!Array<!proto.spine.core.MessageId>} value
 * @return {!proto.spine.system.server.EntityDeleted} returns this
*/


proto.spine.system.server.EntityDeleted.prototype.setSignalIdList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.spine.core.MessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityDeleted.prototype.addSignalId = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.core.MessageId, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spine.system.server.EntityDeleted} returns this
 */


proto.spine.system.server.EntityDeleted.prototype.clearSignalIdList = function () {
  return this.setSignalIdList([]);
};
/**
 * optional google.protobuf.Timestamp when = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.EntityDeleted.prototype.getWhen = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.EntityDeleted} returns this
*/


proto.spine.system.server.EntityDeleted.prototype.setWhen = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityDeleted} returns this
 */


proto.spine.system.server.EntityDeleted.prototype.clearWhen = function () {
  return this.setWhen(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityDeleted.prototype.hasWhen = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional spine.core.Version version = 4;
 * @return {?proto.spine.core.Version}
 */


proto.spine.system.server.EntityDeleted.prototype.getVersion = function () {
  return (
    /** @type{?proto.spine.core.Version} */
    jspb.Message.getWrapperField(this, spine_core_version_pb.Version, 4)
  );
};
/**
 * @param {?proto.spine.core.Version|undefined} value
 * @return {!proto.spine.system.server.EntityDeleted} returns this
*/


proto.spine.system.server.EntityDeleted.prototype.setVersion = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityDeleted} returns this
 */


proto.spine.system.server.EntityDeleted.prototype.clearVersion = function () {
  return this.setVersion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityDeleted.prototype.hasVersion = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * optional bool marked_as_deleted = 5;
 * @return {boolean}
 */


proto.spine.system.server.EntityDeleted.prototype.getMarkedAsDeleted = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 5, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.spine.system.server.EntityDeleted} returns this
 */


proto.spine.system.server.EntityDeleted.prototype.setMarkedAsDeleted = function (value) {
  return jspb.Message.setOneofField(this, 5, proto.spine.system.server.EntityDeleted.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.spine.system.server.EntityDeleted} returns this
 */


proto.spine.system.server.EntityDeleted.prototype.clearMarkedAsDeleted = function () {
  return jspb.Message.setOneofField(this, 5, proto.spine.system.server.EntityDeleted.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityDeleted.prototype.hasMarkedAsDeleted = function () {
  return jspb.Message.getField(this, 5) != null;
};
/**
 * optional bool removed_from_storage = 6;
 * @return {boolean}
 */


proto.spine.system.server.EntityDeleted.prototype.getRemovedFromStorage = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 6, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.spine.system.server.EntityDeleted} returns this
 */


proto.spine.system.server.EntityDeleted.prototype.setRemovedFromStorage = function (value) {
  return jspb.Message.setOneofField(this, 6, proto.spine.system.server.EntityDeleted.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.spine.system.server.EntityDeleted} returns this
 */


proto.spine.system.server.EntityDeleted.prototype.clearRemovedFromStorage = function () {
  return jspb.Message.setOneofField(this, 6, proto.spine.system.server.EntityDeleted.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityDeleted.prototype.hasRemovedFromStorage = function () {
  return jspb.Message.getField(this, 6) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.spine.system.server.EntityUnarchived.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EntityUnarchived.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EntityUnarchived.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EntityUnarchived} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EntityUnarchived.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      entity: (f = msg.getEntity()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      signalIdList: jspb.Message.toObjectList(msg.getSignalIdList(), spine_core_diagnostics_pb.MessageId.toObject, includeInstance),
      when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      version: (f = msg.getVersion()) && spine_core_version_pb.Version.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityUnarchived}
 */


proto.spine.system.server.EntityUnarchived.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityUnarchived();
  return proto.spine.system.server.EntityUnarchived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityUnarchived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityUnarchived}
 */


proto.spine.system.server.EntityUnarchived.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setEntity(value);
        break;

      case 2:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.addSignalId(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhen(value);
        break;

      case 4:
        var value = new spine_core_version_pb.Version();
        reader.readMessage(value, spine_core_version_pb.Version.deserializeBinaryFromReader);
        msg.setVersion(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EntityUnarchived.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityUnarchived.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityUnarchived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EntityUnarchived.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEntity();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getSignalIdList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getWhen();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getVersion();

  if (f != null) {
    writer.writeMessage(4, f, spine_core_version_pb.Version.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId entity = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityUnarchived.prototype.getEntity = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EntityUnarchived} returns this
*/


proto.spine.system.server.EntityUnarchived.prototype.setEntity = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityUnarchived} returns this
 */


proto.spine.system.server.EntityUnarchived.prototype.clearEntity = function () {
  return this.setEntity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityUnarchived.prototype.hasEntity = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * repeated spine.core.MessageId signal_id = 2;
 * @return {!Array<!proto.spine.core.MessageId>}
 */


proto.spine.system.server.EntityUnarchived.prototype.getSignalIdList = function () {
  return (
    /** @type{!Array<!proto.spine.core.MessageId>} */
    jspb.Message.getRepeatedWrapperField(this, spine_core_diagnostics_pb.MessageId, 2)
  );
};
/**
 * @param {!Array<!proto.spine.core.MessageId>} value
 * @return {!proto.spine.system.server.EntityUnarchived} returns this
*/


proto.spine.system.server.EntityUnarchived.prototype.setSignalIdList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.spine.core.MessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityUnarchived.prototype.addSignalId = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.core.MessageId, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spine.system.server.EntityUnarchived} returns this
 */


proto.spine.system.server.EntityUnarchived.prototype.clearSignalIdList = function () {
  return this.setSignalIdList([]);
};
/**
 * optional google.protobuf.Timestamp when = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.EntityUnarchived.prototype.getWhen = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.EntityUnarchived} returns this
*/


proto.spine.system.server.EntityUnarchived.prototype.setWhen = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityUnarchived} returns this
 */


proto.spine.system.server.EntityUnarchived.prototype.clearWhen = function () {
  return this.setWhen(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityUnarchived.prototype.hasWhen = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional spine.core.Version version = 4;
 * @return {?proto.spine.core.Version}
 */


proto.spine.system.server.EntityUnarchived.prototype.getVersion = function () {
  return (
    /** @type{?proto.spine.core.Version} */
    jspb.Message.getWrapperField(this, spine_core_version_pb.Version, 4)
  );
};
/**
 * @param {?proto.spine.core.Version|undefined} value
 * @return {!proto.spine.system.server.EntityUnarchived} returns this
*/


proto.spine.system.server.EntityUnarchived.prototype.setVersion = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityUnarchived} returns this
 */


proto.spine.system.server.EntityUnarchived.prototype.clearVersion = function () {
  return this.setVersion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityUnarchived.prototype.hasVersion = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.spine.system.server.EntityRestored.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.EntityRestored.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.EntityRestored.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.EntityRestored} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.EntityRestored.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      entity: (f = msg.getEntity()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      signalIdList: jspb.Message.toObjectList(msg.getSignalIdList(), spine_core_diagnostics_pb.MessageId.toObject, includeInstance),
      when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      version: (f = msg.getVersion()) && spine_core_version_pb.Version.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityRestored}
 */


proto.spine.system.server.EntityRestored.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityRestored();
  return proto.spine.system.server.EntityRestored.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityRestored} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityRestored}
 */


proto.spine.system.server.EntityRestored.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setEntity(value);
        break;

      case 2:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.addSignalId(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhen(value);
        break;

      case 4:
        var value = new spine_core_version_pb.Version();
        reader.readMessage(value, spine_core_version_pb.Version.deserializeBinaryFromReader);
        msg.setVersion(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.EntityRestored.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityRestored.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityRestored} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.EntityRestored.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEntity();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getSignalIdList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getWhen();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getVersion();

  if (f != null) {
    writer.writeMessage(4, f, spine_core_version_pb.Version.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId entity = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityRestored.prototype.getEntity = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.EntityRestored} returns this
*/


proto.spine.system.server.EntityRestored.prototype.setEntity = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityRestored} returns this
 */


proto.spine.system.server.EntityRestored.prototype.clearEntity = function () {
  return this.setEntity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityRestored.prototype.hasEntity = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * repeated spine.core.MessageId signal_id = 2;
 * @return {!Array<!proto.spine.core.MessageId>}
 */


proto.spine.system.server.EntityRestored.prototype.getSignalIdList = function () {
  return (
    /** @type{!Array<!proto.spine.core.MessageId>} */
    jspb.Message.getRepeatedWrapperField(this, spine_core_diagnostics_pb.MessageId, 2)
  );
};
/**
 * @param {!Array<!proto.spine.core.MessageId>} value
 * @return {!proto.spine.system.server.EntityRestored} returns this
*/


proto.spine.system.server.EntityRestored.prototype.setSignalIdList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.spine.core.MessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.core.MessageId}
 */


proto.spine.system.server.EntityRestored.prototype.addSignalId = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.core.MessageId, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spine.system.server.EntityRestored} returns this
 */


proto.spine.system.server.EntityRestored.prototype.clearSignalIdList = function () {
  return this.setSignalIdList([]);
};
/**
 * optional google.protobuf.Timestamp when = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.EntityRestored.prototype.getWhen = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.EntityRestored} returns this
*/


proto.spine.system.server.EntityRestored.prototype.setWhen = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityRestored} returns this
 */


proto.spine.system.server.EntityRestored.prototype.clearWhen = function () {
  return this.setWhen(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityRestored.prototype.hasWhen = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional spine.core.Version version = 4;
 * @return {?proto.spine.core.Version}
 */


proto.spine.system.server.EntityRestored.prototype.getVersion = function () {
  return (
    /** @type{?proto.spine.core.Version} */
    jspb.Message.getWrapperField(this, spine_core_version_pb.Version, 4)
  );
};
/**
 * @param {?proto.spine.core.Version|undefined} value
 * @return {!proto.spine.system.server.EntityRestored} returns this
*/


proto.spine.system.server.EntityRestored.prototype.setVersion = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.EntityRestored} returns this
 */


proto.spine.system.server.EntityRestored.prototype.clearVersion = function () {
  return this.setVersion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.EntityRestored.prototype.hasVersion = function () {
  return jspb.Message.getField(this, 4) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.system.server.MigrationApplied.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.system.server.MigrationApplied.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.system.server.MigrationApplied} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.system.server.MigrationApplied.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      entity: (f = msg.getEntity()) && spine_core_diagnostics_pb.MessageId.toObject(includeInstance, f),
      when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.MigrationApplied}
 */


proto.spine.system.server.MigrationApplied.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.MigrationApplied();
  return proto.spine.system.server.MigrationApplied.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.MigrationApplied} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.MigrationApplied}
 */


proto.spine.system.server.MigrationApplied.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_core_diagnostics_pb.MessageId();
        reader.readMessage(value, spine_core_diagnostics_pb.MessageId.deserializeBinaryFromReader);
        msg.setEntity(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhen(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.system.server.MigrationApplied.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.MigrationApplied.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.MigrationApplied} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.system.server.MigrationApplied.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEntity();

  if (f != null) {
    writer.writeMessage(1, f, spine_core_diagnostics_pb.MessageId.serializeBinaryToWriter);
  }

  f = message.getWhen();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional spine.core.MessageId entity = 1;
 * @return {?proto.spine.core.MessageId}
 */


proto.spine.system.server.MigrationApplied.prototype.getEntity = function () {
  return (
    /** @type{?proto.spine.core.MessageId} */
    jspb.Message.getWrapperField(this, spine_core_diagnostics_pb.MessageId, 1)
  );
};
/**
 * @param {?proto.spine.core.MessageId|undefined} value
 * @return {!proto.spine.system.server.MigrationApplied} returns this
*/


proto.spine.system.server.MigrationApplied.prototype.setEntity = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.MigrationApplied} returns this
 */


proto.spine.system.server.MigrationApplied.prototype.clearEntity = function () {
  return this.setEntity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.MigrationApplied.prototype.hasEntity = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional google.protobuf.Timestamp when = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.system.server.MigrationApplied.prototype.getWhen = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.system.server.MigrationApplied} returns this
*/


proto.spine.system.server.MigrationApplied.prototype.setWhen = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.system.server.MigrationApplied} returns this
 */


proto.spine.system.server.MigrationApplied.prototype.clearWhen = function () {
  return this.setWhen(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.system.server.MigrationApplied.prototype.hasWhen = function () {
  return jspb.Message.getField(this, 2) != null;
};

goog.object.extend(exports, proto.spine.system.server); // Generated by Spine ProtoJs Plugin

var ObjectParser = require('../../../../client/parser/object-parser.js')["default"];

var TypeParsers = require('../../../../client/parser/type-parsers.js')["default"];

proto.spine.system.server.EventDispatchedToReactor.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EventDispatchedToReactor.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EventDispatchedToReactor.Parser.prototype.constructor = proto.spine.system.server.EventDispatchedToReactor.Parser;

proto.spine.system.server.EventDispatchedToReactor.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EventDispatchedToReactor();

  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }

  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      var _value = TypeParsers.parserFor('type.spine.io/spine.core.Event').fromObject(obj.payload);

      msg.setPayload(_value);
    }
  }

  if (obj.whenDispatched !== undefined) {
    if (obj.whenDispatched === null) {
      msg.setWhenDispatched(null);
    } else {
      var _value2 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.whenDispatched);

      msg.setWhenDispatched(_value2);
    }
  }

  if (obj.entityType !== undefined) {
    if (obj.entityType === null) {
      msg.setEntityType(null);
    } else {
      var _value3 = TypeParsers.parserFor('type.spine.io/spine.system.server.EntityTypeName').fromObject(obj.entityType);

      msg.setEntityType(_value3);
    }
  }

  return msg;
};

proto.spine.system.server.MigrationApplied.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.MigrationApplied.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.MigrationApplied.Parser.prototype.constructor = proto.spine.system.server.MigrationApplied.Parser;

proto.spine.system.server.MigrationApplied.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.MigrationApplied();

  if (obj.entity !== undefined) {
    if (obj.entity === null) {
      msg.setEntity(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.entity);
      msg.setEntity(value);
    }
  }

  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      var _value4 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.when);

      msg.setWhen(_value4);
    }
  }

  return msg;
};

proto.spine.system.server.CommandDispatchedToHandler.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.CommandDispatchedToHandler.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.CommandDispatchedToHandler.Parser.prototype.constructor = proto.spine.system.server.CommandDispatchedToHandler.Parser;

proto.spine.system.server.CommandDispatchedToHandler.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.CommandDispatchedToHandler();

  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }

  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      var _value5 = TypeParsers.parserFor('type.spine.io/spine.core.Command').fromObject(obj.payload);

      msg.setPayload(_value5);
    }
  }

  if (obj.whenDispatched !== undefined) {
    if (obj.whenDispatched === null) {
      msg.setWhenDispatched(null);
    } else {
      var _value6 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.whenDispatched);

      msg.setWhenDispatched(_value6);
    }
  }

  if (obj.entityType !== undefined) {
    if (obj.entityType === null) {
      msg.setEntityType(null);
    } else {
      var _value7 = TypeParsers.parserFor('type.spine.io/spine.system.server.EntityTypeName').fromObject(obj.entityType);

      msg.setEntityType(_value7);
    }
  }

  return msg;
};

proto.spine.system.server.EntityRestored.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EntityRestored.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EntityRestored.Parser.prototype.constructor = proto.spine.system.server.EntityRestored.Parser;

proto.spine.system.server.EntityRestored.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EntityRestored();

  if (obj.entity !== undefined) {
    if (obj.entity === null) {
      msg.setEntity(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.entity);
      msg.setEntity(value);
    }
  }

  if (obj.signalId !== undefined && obj.signalId !== null) {
    obj.signalId.forEach(function (listItem, index, array) {
      if (listItem === null) {
        msg.addSignalId(null);
      } else {
        var _value8 = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(listItem);

        msg.addSignalId(_value8);
      }
    });
  }

  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      var _value9 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.when);

      msg.setWhen(_value9);
    }
  }

  if (obj.version !== undefined) {
    if (obj.version === null) {
      msg.setVersion(null);
    } else {
      var _value10 = TypeParsers.parserFor('type.spine.io/spine.core.Version').fromObject(obj.version);

      msg.setVersion(_value10);
    }
  }

  return msg;
};

proto.spine.system.server.EventImported.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EventImported.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EventImported.Parser.prototype.constructor = proto.spine.system.server.EventImported.Parser;

proto.spine.system.server.EventImported.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EventImported();

  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }

  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      var _value11 = TypeParsers.parserFor('type.spine.io/spine.core.Event').fromObject(obj.payload);

      msg.setPayload(_value11);
    }
  }

  if (obj.whenImported !== undefined) {
    if (obj.whenImported === null) {
      msg.setWhenImported(null);
    } else {
      var _value12 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.whenImported);

      msg.setWhenImported(_value12);
    }
  }

  if (obj.entityType !== undefined) {
    if (obj.entityType === null) {
      msg.setEntityType(null);
    } else {
      var _value13 = TypeParsers.parserFor('type.spine.io/spine.system.server.EntityTypeName').fromObject(obj.entityType);

      msg.setEntityType(_value13);
    }
  }

  return msg;
};

proto.spine.system.server.EntityStateChanged.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EntityStateChanged.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EntityStateChanged.Parser.prototype.constructor = proto.spine.system.server.EntityStateChanged.Parser;

proto.spine.system.server.EntityStateChanged.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EntityStateChanged();

  if (obj.entity !== undefined) {
    if (obj.entity === null) {
      msg.setEntity(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.entity);
      msg.setEntity(value);
    }
  }

  if (obj.oldState !== undefined) {
    if (obj.oldState === null) {
      msg.setOldState(null);
    } else {
      var _value14 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Any').fromObject(obj.oldState);

      msg.setOldState(_value14);
    }
  }

  if (obj.newState !== undefined) {
    if (obj.newState === null) {
      msg.setNewState(null);
    } else {
      var _value15 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Any').fromObject(obj.newState);

      msg.setNewState(_value15);
    }
  }

  if (obj.signalId !== undefined && obj.signalId !== null) {
    obj.signalId.forEach(function (listItem, index, array) {
      if (listItem === null) {
        msg.addSignalId(null);
      } else {
        var _value16 = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(listItem);

        msg.addSignalId(_value16);
      }
    });
  }

  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      var _value17 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.when);

      msg.setWhen(_value17);
    }
  }

  if (obj.newVersion !== undefined) {
    if (obj.newVersion === null) {
      msg.setNewVersion(null);
    } else {
      var _value18 = TypeParsers.parserFor('type.spine.io/spine.core.Version').fromObject(obj.newVersion);

      msg.setNewVersion(_value18);
    }
  }

  return msg;
};

proto.spine.system.server.EntityArchived.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EntityArchived.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EntityArchived.Parser.prototype.constructor = proto.spine.system.server.EntityArchived.Parser;

proto.spine.system.server.EntityArchived.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EntityArchived();

  if (obj.entity !== undefined) {
    if (obj.entity === null) {
      msg.setEntity(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.entity);
      msg.setEntity(value);
    }
  }

  if (obj.signalId !== undefined && obj.signalId !== null) {
    obj.signalId.forEach(function (listItem, index, array) {
      if (listItem === null) {
        msg.addSignalId(null);
      } else {
        var _value19 = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(listItem);

        msg.addSignalId(_value19);
      }
    });
  }

  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      var _value20 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.when);

      msg.setWhen(_value20);
    }
  }

  if (obj.version !== undefined) {
    if (obj.version === null) {
      msg.setVersion(null);
    } else {
      var _value21 = TypeParsers.parserFor('type.spine.io/spine.core.Version').fromObject(obj.version);

      msg.setVersion(_value21);
    }
  }

  return msg;
};

proto.spine.system.server.EntityUnarchived.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EntityUnarchived.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EntityUnarchived.Parser.prototype.constructor = proto.spine.system.server.EntityUnarchived.Parser;

proto.spine.system.server.EntityUnarchived.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EntityUnarchived();

  if (obj.entity !== undefined) {
    if (obj.entity === null) {
      msg.setEntity(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.entity);
      msg.setEntity(value);
    }
  }

  if (obj.signalId !== undefined && obj.signalId !== null) {
    obj.signalId.forEach(function (listItem, index, array) {
      if (listItem === null) {
        msg.addSignalId(null);
      } else {
        var _value22 = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(listItem);

        msg.addSignalId(_value22);
      }
    });
  }

  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      var _value23 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.when);

      msg.setWhen(_value23);
    }
  }

  if (obj.version !== undefined) {
    if (obj.version === null) {
      msg.setVersion(null);
    } else {
      var _value24 = TypeParsers.parserFor('type.spine.io/spine.core.Version').fromObject(obj.version);

      msg.setVersion(_value24);
    }
  }

  return msg;
};

proto.spine.system.server.EntityCreated.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EntityCreated.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EntityCreated.Parser.prototype.constructor = proto.spine.system.server.EntityCreated.Parser;

proto.spine.system.server.EntityCreated.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EntityCreated();

  if (obj.entity !== undefined) {
    if (obj.entity === null) {
      msg.setEntity(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.entity);
      msg.setEntity(value);
    }
  }

  if (obj.kind !== undefined) {
    if (obj.kind !== null) {
      var _value25 = proto.EntityOption.Kind[obj.kind];
      msg.setKind(_value25);
    }
  }

  return msg;
};

proto.spine.system.server.EntityDeleted.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EntityDeleted.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EntityDeleted.Parser.prototype.constructor = proto.spine.system.server.EntityDeleted.Parser;

proto.spine.system.server.EntityDeleted.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EntityDeleted();

  if (obj.entity !== undefined) {
    if (obj.entity === null) {
      msg.setEntity(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.entity);
      msg.setEntity(value);
    }
  }

  if (obj.signalId !== undefined && obj.signalId !== null) {
    obj.signalId.forEach(function (listItem, index, array) {
      if (listItem === null) {
        msg.addSignalId(null);
      } else {
        var _value26 = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(listItem);

        msg.addSignalId(_value26);
      }
    });
  }

  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      var _value27 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.when);

      msg.setWhen(_value27);
    }
  }

  if (obj.version !== undefined) {
    if (obj.version === null) {
      msg.setVersion(null);
    } else {
      var _value28 = TypeParsers.parserFor('type.spine.io/spine.core.Version').fromObject(obj.version);

      msg.setVersion(_value28);
    }
  }

  if (obj.markedAsDeleted !== undefined) {
    if (obj.markedAsDeleted !== null) {
      var _value29 = obj.markedAsDeleted;
      msg.setMarkedAsDeleted(_value29);
    }
  }

  if (obj.removedFromStorage !== undefined) {
    if (obj.removedFromStorage !== null) {
      var _value30 = obj.removedFromStorage;
      msg.setRemovedFromStorage(_value30);
    }
  }

  return msg;
};

proto.spine.system.server.EventDispatchedToSubscriber.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.system.server.EventDispatchedToSubscriber.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.system.server.EventDispatchedToSubscriber.Parser.prototype.constructor = proto.spine.system.server.EventDispatchedToSubscriber.Parser;

proto.spine.system.server.EventDispatchedToSubscriber.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.system.server.EventDispatchedToSubscriber();

  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.core.MessageId').fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }

  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      var _value31 = TypeParsers.parserFor('type.spine.io/spine.core.Event').fromObject(obj.payload);

      msg.setPayload(_value31);
    }
  }

  if (obj.whenDispatched !== undefined) {
    if (obj.whenDispatched === null) {
      msg.setWhenDispatched(null);
    } else {
      var _value32 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.whenDispatched);

      msg.setWhenDispatched(_value32);
    }
  }

  if (obj.entityType !== undefined) {
    if (obj.entityType === null) {
      msg.setEntityType(null);
    } else {
      var _value33 = TypeParsers.parserFor('type.spine.io/spine.system.server.EntityTypeName').fromObject(obj.entityType);

      msg.setEntityType(_value33);
    }
  }

  return msg;
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EventDispatchedToReactor.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EventDispatchedToReactor';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.MigrationApplied.typeUrl = function () {
  return 'type.spine.io/spine.system.server.MigrationApplied';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.CommandDispatchedToHandler.typeUrl = function () {
  return 'type.spine.io/spine.system.server.CommandDispatchedToHandler';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EntityRestored.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EntityRestored';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EventImported.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EventImported';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EntityStateChanged.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EntityStateChanged';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EntityArchived.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EntityArchived';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EntityUnarchived.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EntityUnarchived';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EntityCreated.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EntityCreated';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EntityDeleted.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EntityDeleted';
}; // Generated by Spine ProtoJs Plugin


proto.spine.system.server.EventDispatchedToSubscriber.typeUrl = function () {
  return 'type.spine.io/spine.system.server.EventDispatchedToSubscriber';
};
//# sourceMappingURL=entity_log_events_pb.js.map